// import node module libraries
import { Card, Form, Button } from "react-bootstrap";
import { useState } from "react";
import dayjs from "dayjs";
// import custom components
import GKTagsInput from "components/elements/tags/GKTagsInput";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import ToastMessage from "components/Dialog/ToastMessage";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import RenderContent from "./RenderContent";
import deleteIcon from "../../../../assets/images/add-course/delete.svg";
import editIcon from "../../../../assets/images/add-course/edit.svg";
import {
  createCourseDetails,
  deleteCourseContent,
  deleteCourseSection,
  getSignedUrl,
} from "ServerAPI/serverAPI";
import { Cookies, useCookies } from "react-cookie";
import ConfirmationDialog from "components/Dialog/ConfirmationDialog";
import { useToast } from "context/toast-context/ToastProvider";

const Review = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    previous,
    setStep,
    allFiles,
    allSections,
    setAllSections,
    courseDetails,
    activeSection,
    setActiveSection,
    showContentPageForEdit,
    activeContent,
    setActiveContent,
    setActiveQuiz,
    savedCourse,
    editSavedCourse,
    allContent,
    setAllContent,
    courseId,
  } = props;

  const [cookies, setCookies] = useCookies();
  const [openDeleteContentDialog, setOpenDeleteContentDialog] = useState(false);
  const [openDeleteSectionDialog, setOpenDeleteSectionDialog] = useState(false);
  const [clickedContentForDelete, setClickedContentForDelete] = useState({});
  const [shouldPublishCourse, setShouldPublishCourse] = useState(false);
  const [clickedSectionDetails, setClickedSectionDetails] = useState({});
  const [isContentDeleteLoading, setIsContentDeleteLoading] = useState(false);
  const [isSectionDeleteLoading, setIsSectionDeleteLoading] = useState(false);
  const { showToast } = useToast();
  const navigate = useNavigate();

  // Validate all scheduled quizzes before saving/publishing
  const validateScheduledQuizzes = () => {
    for (const section of allSections) {
      const contents = section.content || section.courseContent || [];
      for (const content of contents) {
        if (!content.scheduledAttempt) continue;

        const { startDate, startTime, endDate, endTime, quizTimer, contentTitle } = content;
        const quizName = contentTitle || "Untitled Quiz";

        if (!startDate || !startTime || !endDate || !endTime) {
          const msg = `"${quizName}" is marked as scheduled but is missing scheduling fields (Start/End Date/Time). Please edit this quiz to fix it.`;
          showToast(msg, "error");
          return false;
        }

        const startObj = dayjs(`${startDate} ${startTime}`);
        const endObj = dayjs(`${endDate} ${endTime}`);
        const durationInMinutes = endObj.diff(startObj, "minute");

        if (durationInMinutes <= 0) {
          const msg = `"${quizName}": Scheduled End Date/Time must be after Start Date/Time.`;
          showToast(msg, "error");
          return false;
        }

        if (quizTimer && durationInMinutes < Number(quizTimer)) {
          const msg = `"${quizName}": Scheduled window (${durationInMinutes} mins) is less than the Quiz Timer (${quizTimer} mins). Please increase the schedule window or reduce the quiz timer.`;
          showToast(msg, "error");
          return false;
        }
      }
    }
    return true;
  };

  const sanitizeSchedulingFields = (sections) => {
    return sections.map((section) => {
      const sectionClone = { ...section };
      const currentContent = sectionClone.content || sectionClone.courseContent || [];

      // Remove scheduling fields when scheduledAttempt is false
      const sanitizedContent = currentContent.map((content) => {
        if (content.scheduledAttempt === false) {
          const { startDate, startTime, endDate, endTime, ...rest } = content;
          return rest;
        }
        return content;
      });

      sectionClone.content = sanitizedContent;
      sectionClone.courseContent = sanitizedContent.filter(c => c.contentType !== "quizSubjective");
      sectionClone.subjectiveQuizzes = sanitizedContent.filter(c => c.contentType === "quizSubjective");

      return sectionClone;
    });
  };

  const publishCourse = async () => {
    if (!validateScheduledQuizzes()) return;
    setIsLoading(true);
    handleCloseForPublishCourse();
    const sanitizedSections = sanitizeSchedulingFields(allSections);

    const payload = {
      authorUserId: cookies.userId,
      authorEmail: cookies.email,
      courseDetails,
      courseContent: sanitizedSections,
      creationType: "publishCourse",
    };
    const response = await createCourseDetails(payload);
    if (response.status === 200) {
      showToast("Course published successfully", "success");
      navigate("/courses");
    } else {
      showToast("Something went wrong", "error");
    }
    setIsLoading(false);
  };

  const draftCourse = async () => {
    if (!validateScheduledQuizzes()) return;
    setIsLoading(true);
    const sanitizedSections = sanitizeSchedulingFields(allSections);

    const payload = {
      authorUserId: cookies.userId,
      authorEmail: cookies.email,
      courseDetails,
      courseContent: sanitizedSections,
      creationType: "saveCourse",
    };
    const response = await createCourseDetails(payload);
    if (response.status === 200) {
      showToast("Course saved successfully", "success");
      navigate("/courses");
    } else {
      showToast("Something went wrong", "error");
    }
    setIsLoading(false);
  };

  const handleCourseUpdate = async () => {
    if (!validateScheduledQuizzes()) return;
    setIsLoading(true);
    const sectionIds = allSections.map((section) => {
      return section.sectionId;
    });

    const sanitizedSections = sanitizeSchedulingFields(allSections);

    const payload = {
      authorUserId: cookies.userId,
      authorEmail: cookies.email,
      courseDetails,
      courseContent: sanitizedSections,
      creationType: "courseUpdate",
      sectionIds: sectionIds,
    };
    console.log("allSections", payload);

    const response = await createCourseDetails(payload);
    setIsLoading(false);
    if (response.status === 200) {
      navigate("/courses");
    }
  };

  const updateContent = (sectionIndex, contentIndex) => {
    showContentPageForEdit();
  };
  const UpdateCourseDetails = () => {
    setStep(1);
  };
  const updateSectionName = (sectionIndex) => {
    setStep(2, true);
  };

  const handleDeleteContent = async (clickedContent) => {
    const sections = [...allSections];
    sections.forEach((section) => {
      // if (section.sectionNumber === clickedContent.sectionNumber) {
      //   delete section.courseContent;
      //   section.content.forEach((content, index) => {
      //     if (content.contentNumber === clickedContent.contentNumber) {
      //       section.content.splice(index, 1);
      //     }
      //   });
      // }
      if (section.sectionId === clickedContent.sectionId) {
        delete section.courseContent;
        section.content.forEach((content, index) => {
          if (content.contentNumber === clickedContent.contentNumber) {
            section.content.splice(index, 1);
          }
        });
      }
    });
    console.log("sections", sections);

    setAllSections(sections);
    setAllContent([]);

    // delete respective contentFile
    if (
      clickedContent.contentType === "video" ||
      clickedContent.contentType === "supplementaryMaterial"
    ) {
      const payload = {
        courseId: courseId ? courseId : savedCourse?.courseId,
        sectionId: clickedContent?.sectionId,
        fileName: clickedContent?.contentFileName,
        method: "DELETE",
        userId: cookies?.userId,
      };

      await getSignedUrl(payload);
      // ——————————————————————————————————
        //  VECTOR DELETE – VIDEO & PDF
        // ——————————————————————————————————
if (clickedContentForDelete.contentType === "video" ||
      clickedContent.contentType === "supplementaryMaterial") {
          const { deleteFileVectors } = await import('ServerAPI/serverAPI');

          deleteFileVectors(
            cookies.organizationId,                    // organization_id
            clickedContentForDelete?.contentFileName,  // file_name
            clickedContentForDelete?.sectionId         // section_id (optional)
          ).catch((err) => {
            console.error('Vector deletion failed (non-blocking):', err);
          });
        }
        // ——————————————————————————————————
    }
  };

  const handleDeleteContentDialogClose = () => {
    setOpenDeleteContentDialog(false);
  };
  const handleDeleteSectionDialogClose = () => {
    setOpenDeleteSectionDialog(false);
  };
  const handleDeleteContentDialogConfirm = async () => {
    console.log("e_", clickedContentForDelete);
    setIsContentDeleteLoading(true);
    if (clickedContentForDelete?.contentId) {
      const payload = {
        contentId: clickedContentForDelete?.contentId,
        sectionId: clickedContentForDelete?.sectionId,
        contentType: clickedContentForDelete?.contentType,
        creationType: "contentDelete",
        authorUserId: cookies?.userId,
        courseId: courseId ? courseId : savedCourse?.courseId,
      };
      const response = await deleteCourseContent(payload);

      if (response?.status === 200) {
        handleDeleteContent(clickedContentForDelete);
        showToast("Content deleted successfully", "success");
        handleDeleteContentDialogClose();
      } else {
        showToast("Content deleted successfully", "error");
      }
    } else {
      handleDeleteContent(clickedContentForDelete);
      showToast("Content deleted successfully", "success");
      handleDeleteContentDialogClose();
    }
    setIsContentDeleteLoading(false);
  };

  const handleCloseForPublishCourse = () => {
    setShouldPublishCourse(false);
  };
  const handleDeleteSection = async () => {
    setIsSectionDeleteLoading(true);
    console.log("clickedSectionDetails", clickedSectionDetails);
    const filteredSection = allSections.filter((section) => {
      return section?.sectionId !== clickedSectionDetails?.sectionId;
    });
    const payload = {
      sectionId: clickedSectionDetails?.sectionId,
      sectionTitle: clickedSectionDetails?.sectionTitle,
      courseId: courseId ? courseId : savedCourse?.courseId,
      authorUserId: cookies?.userId,
      creationType: "sectionDelete",
    };
    const response = await deleteCourseSection(payload);
    if (response.status === 200) {
      setAllSections(filteredSection);
      handleDeleteSectionDialogClose();
      showToast("Section deleted", "success");
    } else {
      showToast("Something went wrong", "error");
    }
    setIsSectionDeleteLoading(false);
  };
  return (
    <>
      <Form>
        {/* Card */}
        <Card>
          <Card.Body>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <span className=" text-dark fw-bold">Course Details</span>
              </AccordionSummary>
              <AccordionDetails>
                <div
                  className="d-flex justify-content-end "
                  onClick={UpdateCourseDetails}
                >
                  <img
                    className="cursor-pointer"
                    src={editIcon}
                    alt="edit icon"
                  />
                  <div className="text-primary cursor-pointer">Edit</div>
                </div>
                <div>
                  <span className=" text-dark fw-bold">Course Title: </span>
                  <span>{courseDetails?.courseTitle}</span>
                </div>

                <div className="mt-4">
                  <span className=" text-dark fw-bold">Course Department:</span>
                  <span> {courseDetails?.courseDepartment}</span>
                </div>
                <div className="mt-4">
                  <span className=" text-dark fw-bold">Course Process: </span>
                  <span> {courseDetails?.courseDomain}</span>
                </div>

                <div className="mt-4">
                  <span className=" text-dark fw-bold">Course Level: </span>
                  <span> {courseDetails?.courseLevel}</span>
                </div>
                <div className="mt-4">
                  <span className=" text-dark fw-bold">
                    Course Description:
                  </span>
                  <span> {courseDetails?.courseDescription}</span>
                </div>
                {Array.isArray(courseDetails?.learningOutcome) && courseDetails.learningOutcome.length > 0 && (
                  <div className="mt-4">
                    <span className="text-dark fw-bold d-block mb-2">Course Outcomes:</span>
                    <ul className="list-unstyled ps-3">
                      {courseDetails.learningOutcome.map((outcome, idx) => (
                        <li key={idx} className="mb-1">
                          <span className="fw-bold text-primary me-2">CO{idx + 1}:</span>
                          <span>{typeof outcome === 'string' ? outcome.replace(/^CO\d+:\s*/, '') : outcome}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </AccordionDetails>
            </Accordion>
            <Accordion className="mt-5 border-0">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <div className=" text-dark fw-bold">Course Section</div>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  {/* courseInfo?.courseContent? */}
                  {allSections.length > 0
                    ? allSections.map((content, sectionIndex) => {
                        return (
                          <>
                            <div>
                              <Accordion className="mb-3">
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel5-content"
                                  id="panel5-header"
                                >
                                  <div> {content?.sectionTitle}</div>
                                  <div
                                    className="d-flex justify-content-end mx-2"
                                    onClick={() => {
                                      setActiveSection(content);
                                      updateSectionName(sectionIndex);
                                    }}
                                  >
                                    <img
                                      className="cursor-pointer text-primary"
                                      src={editIcon}
                                      alt="edit icon"
                                    />
                                  </div>
                                  {allSections?.length > 1 ? (
                                    <>
                                      <img
                                        className="cursor-pointer"
                                        src={deleteIcon}
                                        alt="delete icon"
                                        onClick={() => {
                                          setOpenDeleteSectionDialog(true);
                                          setClickedSectionDetails(content);
                                          // setClickedContentForDelete(ele);
                                          // setOpenDeleteContentDialog(true);
                                        }}
                                      />
                                    </>
                                  ) : null}
                                </AccordionSummary>
                                <AccordionDetails>
                                  {content?.content?.map(
                                    (ele, contentIndex) => {
                                      return (
                                        <>
                                          <div className="mt-3 d-flex justify-content-between">
                                            <div>
                                              <RenderContent
                                                key={contentIndex}
                                                fileName={
                                                  ele?.contentFileName || ""
                                                }
                                                contentTitle={ele?.contentTitle}
                                              />
                                              {ele?.scheduledAttempt && (
                                                <div className="ms-4 mt-1 small">
                                                  <span className="text-primary fw-bold">Scheduled:</span>{" "}
                                                  {ele.startDate} {ele.startTime} to {ele.endDate} {ele.endTime}
                                                </div>
                                              )}
                                              {ele?.isProctored && (
                                                <div className="ms-4 mt-1 small">
                                                  <span className="text-success fw-bold">Proctored</span>
                                                </div>
                                              )}
                                            </div>
                                            <div>
                                              <img
                                                className="cursor-pointer"
                                                src={editIcon}
                                                alt="edit icon"
                                                onClick={() => {
                                                  setActiveSection(content);
                                                  setActiveContent(ele);
                                                  setActiveQuiz(ele);
                                                  console.log("ele_", ele);

                                                  if (
                                                    ele?.contentType === "quiz"
                                                  ) {
                                                    setActiveQuiz(ele);
                                                  }
                                                  updateContent(
                                                    sectionIndex,
                                                    contentIndex
                                                  );
                                                }}
                                              />
                                              {content?.content?.length > 1 ? (
                                                <>
                                                  <img
                                                    className="cursor-pointer"
                                                    src={deleteIcon}
                                                    alt="delete icon"
                                                    onClick={() => {
                                                      setClickedContentForDelete(
                                                        ele
                                                      );
                                                      setOpenDeleteContentDialog(
                                                        true
                                                      );
                                                    }}
                                                  />
                                                </>
                                              ) : null}
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                </AccordionDetails>
                              </Accordion>
                            </div>
                          </>
                        );
                      })
                    : null}
                </div>
              </AccordionDetails>
            </Accordion>
          </Card.Body>
        </Card>
        <div className="d-flex justify-content-between mb-22 mt-5">
          <Button variant="secondary" onClick={previous}>
            Previous
          </Button>

          {isLoading ? (
            <>
              <CircularProgress />
            </>
          ) : editSavedCourse ? (
            <>
              <div className="">
                <Button variant="primary" onClick={handleCourseUpdate}>
                  Update
                </Button>

                {/* <Button
                  variant="primary  mx-2"
                  onClick={() => {
                    setShouldPublishCourse(true);
                  }}
                >
                  Publish
                </Button> */}
              </div>
            </>
          ) : (
            <>
              <div className="">
                <Button variant="primary" onClick={draftCourse}>
                  Save
                </Button>
                {/* <Button
                  variant="primary  mx-2"
                  onClick={() => {
                    setShouldPublishCourse(true);
                  }}
                >
                  Publish
                </Button> */}
              </div>
            </>
          )}
        </div>
      </Form>
      ;{/* confirmation dialog for delete content */}
      <ConfirmationDialog
        open={openDeleteContentDialog}
        handleClose={handleDeleteContentDialogClose}
        handleConfirm={handleDeleteContentDialogConfirm}
        message="Do you want to delete this content"
        isLoading={isContentDeleteLoading}
      />
      {/* confirmation modal for publish course */}
      <ConfirmationDialog
        open={shouldPublishCourse}
        handleClose={handleCloseForPublishCourse}
        handleConfirm={publishCourse}
        message="Do you want to publish this course"
      />
      {/* confirmation dialog for delete section */}
      <ConfirmationDialog
        open={openDeleteSectionDialog}
        handleClose={handleDeleteSectionDialogClose}
        handleConfirm={handleDeleteSection}
        message="Do you want to delete this Section"
        isLoading={isSectionDeleteLoading}
      />
    </>
  );
};
export default Review;
